import car from '@root/joinroot.com/src/assets/availability-map/car';
import homeowners from '@root/joinroot.com/src/assets/availability-map/homeowners';
import renters from '@root/joinroot.com/src/assets/availability-map/renters';

export default [
  {
    title: 'Car',
    productType: 'auto',
    link: 'https://quote.joinroot.com',
    icon: car,
  },
  {
    title: 'Homeowners',
    productType: 'homeowners',
    prefix: 'homeowners-insurance',
    icon: homeowners,
  },
  {
    title: 'Renters',
    productType: 'renters',
    link: 'https://renters.joinroot.com',
    icon: renters,
  },
];
